import * as api from '../api';

export const fetchAllParticipantTypesActions = api.fetchActions('participant-types', 'fetch-all');

export const actionTypes = {
  ...fetchAllParticipantTypesActions.actionTypes,
};

/** Gets all of the participant types for the tenant */
export const fetchAllParticipantTypes = () => api.getThunk('/participant-types', null, fetchAllParticipantTypesActions);
